(function () {
  'use strict';

  /* @ngdoc object
   * @name vctracker
   * @description
   *
   */
  angular
    .module('vctracker', [
    ]);
}());
